export default "__VITE_ASSET__Ox1Kb4dx__"